/* Garden Fragrances: theme.js (no dependencies) */
(function () {
  'use strict';

  var doc = document;
  var root = doc.documentElement;
  var routeRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function $(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }

  /* Toast ---------------------------------------------------------------- */
  var toastTimer;
  function toast(message) {
    var el = $('.toast');
    if (!el) {
      el = doc.createElement('div');
      el.className = 'toast';
      el.setAttribute('role', 'status');
      doc.body.appendChild(el);
    }
    el.textContent = message;
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 3500);
  }

  /* Header: solid background once scrolled ------------------------------- */
  function onScroll() {
    var header = $('[data-site-header]');
    if (header) header.classList.toggle('is-stuck', window.scrollY > 20);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* Sticky offset: height of the fixed header, used by the product sticky bar */
  function updateStickyOffset() {
    var header = $('#shopify-section-header');
    root.style.setProperty('--sticky-offset', (header ? header.offsetHeight : 0) + 'px');
  }
  window.addEventListener('resize', updateStickyOffset, { passive: true });
  updateStickyOffset();

  /* Panels (menu, search, cart) ------------------------------------------ */
  function closePanels() {
    $$('.panel.is-open').forEach(function (p) {
      p.classList.remove('is-open');
      p.setAttribute('aria-hidden', 'true');
    });
    var overlay = $('[data-overlay]');
    if (overlay) overlay.classList.remove('is-visible');
    var header = $('[data-site-header]');
    if (header) header.classList.remove('is-active');
    root.classList.remove('no-scroll');
  }

  function openPanel(name) {
    var panel = $('[data-panel="' + name + '"]');
    if (!panel) return false;
    closePanels();
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    var overlay = $('[data-overlay]');
    if (overlay) overlay.classList.add('is-visible');
    var header = $('[data-site-header]');
    if (header) header.classList.add('is-active');
    root.classList.add('no-scroll');
    if (name === 'search') {
      var input = $('input[type="search"]', panel);
      if (input) setTimeout(function () { input.focus(); }, 250);
    }
    return true;
  }

  /* Cart ----------------------------------------------------------------- */
  async function refreshCart() {
    var res = await fetch(routeRoot + '?sections=cart-drawer');
    var json = await res.json();
    var html = json['cart-drawer'];
    if (!html) return;
    var fresh = $('[data-cart-drawer-inner]', new DOMParser().parseFromString(html, 'text/html'));
    var current = $('[data-cart-drawer-inner]');
    if (!fresh || !current) return;
    current.replaceWith(fresh);
    var count = parseInt(fresh.getAttribute('data-cart-count'), 10) || 0;
    $$('[data-cart-count-bubble]').forEach(function (b) {
      b.textContent = count;
      b.hidden = count === 0;
    });
  }

  async function addToCart(payload, button) {
    var errorEl = button ? button.closest('form') && $('[data-form-error]', button.closest('form')) : null;
    if (errorEl) errorEl.hidden = true;
    if (button) { button.disabled = true; button.classList.add('is-loading'); }
    try {
      var res = await fetch(routeRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      });
      var data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to bag.');
      await refreshCart();
      if (!openPanel('cart')) window.location.href = routeRoot + 'cart';
    } catch (err) {
      if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
      else toast(err.message);
    } finally {
      if (button) { button.disabled = false; button.classList.remove('is-loading'); }
    }
  }

  async function changeLine(line, quantity) {
    try {
      var res = await fetch(routeRoot + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      });
      if (!res.ok) throw new Error('Could not update your bag.');
      if (doc.body.classList.contains('template-cart')) { window.location.reload(); return; }
      await refreshCart();
    } catch (err) {
      toast(err.message);
    }
  }

  /* Delegated clicks ----------------------------------------------------- */
  doc.addEventListener('click', function (e) {
    var t = e.target;

    var toggle = t.closest('[data-toggle]');
    if (toggle) {
      var name = toggle.getAttribute('data-toggle');
      if (openPanel(name)) e.preventDefault();
      return;
    }

    if (t.closest('[data-close]') || t.matches('[data-overlay]')) { closePanels(); return; }

    var quick = t.closest('[data-quick-add]');
    if (quick) {
      e.preventDefault();
      addToCart({ id: quick.getAttribute('data-variant-id'), quantity: 1 }, quick);
      return;
    }

    var qtyChange = t.closest('[data-qty-change]');
    if (qtyChange) {
      e.preventDefault();
      changeLine(parseInt(qtyChange.getAttribute('data-line'), 10), parseInt(qtyChange.getAttribute('data-qty'), 10));
      return;
    }

    var step = t.closest('[data-qty-step]');
    if (step) {
      var input = $('[data-qty-input]', step.closest('.qty'));
      if (input) {
        var next = (parseInt(input.value, 10) || 1) + parseInt(step.getAttribute('data-qty-step'), 10);
        input.value = Math.max(1, next);
      }
      return;
    }

    var thumb = t.closest('[data-thumb]');
    if (thumb) {
      activateMedia(thumb.closest('[data-product-section]'), thumb.getAttribute('data-thumb'));
      return;
    }

    var stickyAdd = t.closest('[data-sticky-add]');
    if (stickyAdd) {
      e.preventDefault();
      var stickySection = stickyAdd.closest('[data-product-section]');
      var realBtn = stickySection && $('[data-add-btn]', stickySection);
      if (realBtn && !realBtn.disabled) realBtn.click();
      return;
    }

    if (t.closest('[data-toggle-filters]')) {
      var filters = $('[data-filters]');
      if (filters) filters.classList.toggle('is-open');
      return;
    }

    if (t.closest('[data-show-recover]')) { toggleRecover(true); return; }
    if (t.closest('[data-hide-recover]')) { toggleRecover(false); }
  });

  doc.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closePanels();
  });

  /* Product form + variants --------------------------------------------- */
  doc.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (form) {
      e.preventDefault();
      var id = $('[data-variant-input]', form).value;
      var qty = parseInt($('[data-qty-input]', form).value, 10) || 1;
      addToCart({ id: id, quantity: qty }, $('[data-add-btn]', form));
      return;
    }
    var confirmMsg = e.target.getAttribute && e.target.getAttribute('data-confirm');
    if (confirmMsg && !window.confirm(confirmMsg)) e.preventDefault();
  });

  function activateMedia(section, mediaId) {
    if (!section || !mediaId) return;
    $$('[data-media-id]', section).forEach(function (s) {
      s.classList.toggle('is-active', s.getAttribute('data-media-id') === String(mediaId));
    });
    $$('[data-thumb]', section).forEach(function (t) {
      t.classList.toggle('is-active', t.getAttribute('data-thumb') === String(mediaId));
    });
  }

  function initProduct(section) {
    var dataEl = $('[data-variants]', section);
    if (!dataEl || section.__gfReady) return;
    section.__gfReady = true;

    var variants = JSON.parse(dataEl.textContent);
    var lowStock = parseInt(dataEl.getAttribute('data-low-stock'), 10) || 0;
    var idInput = $('[data-variant-input]', section);
    var priceEls = $$('[data-price]', section);
    var button = $('[data-add-btn]', section);
    var label = $('[data-btn-label]', section);
    var stickyAddBtn = $('[data-sticky-add]', section);
    var stockEl = $('[data-stock-badge]', section);

    function selectedOptions() {
      return $$('.option', section).map(function (fs) {
        var checked = $('input:checked', fs);
        return checked ? checked.value : null;
      });
    }

    function update() {
      $$('.option', section).forEach(function (fs) {
        var checked = $('input:checked', fs);
        var out = $('[data-option-value]', fs);
        if (checked && out) out.textContent = checked.value;
      });

      var chosen = selectedOptions();
      var variant = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === chosen[i]; });
      });

      if (!variant) {
        button.disabled = true;
        label.textContent = 'Unavailable';
        if (stickyAddBtn) stickyAddBtn.disabled = true;
        return;
      }

      idInput.value = variant.id;
      button.disabled = !variant.available;
      label.textContent = variant.available ? 'Add to bag' : 'Sold out';
      if (stickyAddBtn) {
        stickyAddBtn.disabled = !variant.available;
        stickyAddBtn.textContent = variant.available ? 'Add to bag' : 'Sold out';
      }

      priceEls.forEach(function (priceEl) {
        priceEl.classList.toggle('price--sale', !!variant.compare);
        priceEl.innerHTML = '<span class="price__now">' + variant.price + '</span>' +
          (variant.compare ? '<s class="price__was">' + variant.compare + '</s>' : '');
      });

      if (stockEl) {
        var qty = Math.max(0, variant.qty || 0);
        if (variant.tracked === 'shopify' && variant.available && qty > 0 && qty <= lowStock) {
          stockEl.hidden = false;
          stockEl.textContent = qty + ' ' + (qty === 1 ? 'unit' : 'units') + ' left';
        } else {
          stockEl.hidden = true;
        }
      }

      if (variant.image) {
        activateMedia(section, variant.image);
        var activeImg = $('.product-gallery__slide.is-active img', section);
        var stickyImg = $('.sticky-bar__media img', section);
        if (activeImg && stickyImg) stickyImg.src = activeImg.currentSrc || activeImg.src;
      }
      if (window.history && history.replaceState) {
        history.replaceState(null, '', '?variant=' + variant.id);
      }
    }

    section.addEventListener('change', function (e) {
      if (e.target.closest('.option')) update();
    });

    /* Sticky add-to-bag bar: shows once the real button scrolls out of view. */
    var stickyBar = $('[data-sticky-bar]', section);
    var triggerEl = $('.product-form__row', section);
    if (stickyBar && triggerEl && 'IntersectionObserver' in window) {
      var stickyObserver = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        var pastTop = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        stickyBar.classList.toggle('is-visible', pastTop);
      }, { threshold: 0 });
      stickyObserver.observe(triggerEl);
    }
  }

  /* Collection filters: auto submit ------------------------------------- */
  doc.addEventListener('change', function (e) {
    var el = e.target;
    if (el.matches && el.matches('[data-auto-submit]')) {
      var form = el.closest('form');
      if (form) form.submit();
    }
  });

  /* Recommendations ------------------------------------------------------ */
  function initRecommendations(scope) {
    $$('[data-product-recs]', scope).forEach(async function (el) {
      if (el.__gfReady) return;
      el.__gfReady = true;
      if ($('.product-recs__inner', el)) { el.hidden = false; return; }
      try {
        var res = await fetch(el.getAttribute('data-url'));
        var text = await res.text();
        var inner = $('.product-recs__inner', new DOMParser().parseFromString(text, 'text/html'));
        if (inner) {
          el.innerHTML = inner.outerHTML;
          el.hidden = false;
        }
      } catch (err) { /* recommendations are optional */ }
    });
  }

  /* Password recovery toggle -------------------------------------------- */
  function toggleRecover(show) {
    var recover = $('[data-recover-panel]');
    var login = $('[data-login-panel]');
    if (!recover || !login) return;
    recover.hidden = !show;
    login.hidden = show;
  }

  /* Reveal on scroll ----------------------------------------------------- */
  var observer = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 })
    : null;

  function initReveal(scope) {
    $$('[data-reveal]', scope).forEach(function (el) {
      if (!observer || (window.Shopify && Shopify.designMode)) el.classList.add('is-visible');
      else observer.observe(el);
    });
  }

  /* Init ----------------------------------------------------------------- */
  function init(scope) {
    $$('[data-product-section]', scope).forEach(initProduct);
    initRecommendations(scope);
    initReveal(scope);
  }

  init(doc);
  if (window.location.hash === '#recover') toggleRecover(true);

  // Theme editor: re-initialise sections when merchants edit them.
  doc.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
